import Model from "../../utils/RestModel.js";
import Field from "../../utils/Field.js";

export default new Model(function () {
    this.key = new Field().asString();
    this.language = new Field().asString();
    this.translation = new Field().asString();
}, "LexiconEntry");
